import { Link } from '@mui/material';
import { Box } from '@mui/system';
import Markdown from 'markdown-to-jsx';
import React, { FunctionComponent } from 'react';
import { Link as RouterLink } from 'react-router-dom';

interface Props {
  content: string;
}

const MarkdownRenderer: FunctionComponent<React.PropsWithChildren<Props>> = ({ content }) => {
  // Add options to MarkdownRenderer - to open all <a> links in the markdown content in target=blank and rel="noopener noreferrer"
  const options = {
    overrides: {
      a: {
        component: Link,
        props: {
          target: '_blank',
          rel: 'noopener noreferrer',
          component: RouterLink,
        },
      },
    },
  };

  return (
    <Box sx={{ p: 3 }}>
      <Markdown options={options}>{content}</Markdown>
    </Box>
  );
};

export default MarkdownRenderer;
